/**
 * Month options for select components
 * Returns an array of month objects with value and internationalized label
 */
import { intl } from "dmsbasereact";

export const getMonthOptions = () => [
    { value: 1, label: intl.get("Month.January").d("Janeiro") },
    { value: 2, label: intl.get("Month.February").d("Fevereiro") },
    { value: 3, label: intl.get("Month.March").d("Março") },
    { value: 4, label: intl.get("Month.April").d("Abril") },
    { value: 5, label: intl.get("Month.May").d("Maio") },
    { value: 6, label: intl.get("Month.June").d("Junho") },
    { value: 7, label: intl.get("Month.July").d("Julho") },
    { value: 8, label: intl.get("Month.August").d("Agosto") },
    { value: 9, label: intl.get("Month.September").d("Setembro") },
    { value: 10, label: intl.get("Month.October").d("Outubro") },
    { value: 11, label: intl.get("Month.November").d("Novembro") },
    { value: 12, label: intl.get("Month.December").d("Dezembro") },
];
